import mabcBaseModel from './mabc-base-model.json';

export const getMemberBenefits = (benefitsArray) => {
  const benefitsWithPrunedLinks = benefitsArray.map(({ links, ...rest }) => {
    const prunedLinks = links.filter((link) => !!link);
    return {
      ...rest,
      links: prunedLinks,
    };
  });
  // because "partition" doesn't exist in JS :|
  const [featured, standard] = benefitsWithPrunedLinks.reduce((result, element) => {
    result[element?.isFeatured ? 0 : 1].push(element);
    return result;
  },
  [[], []]);
  return { featured, standard };
};

export const replaceTermFromDict = (str, dict) => {
  let output = str;
  mabcBaseModel.terms.forEach((term) => {
    if (!dict[term] || typeof output.replace !== 'function') return;
    output = output.replace(`{{${term}}}`, dict[term]);
  });
  return output;
};

export const getMabcPromoModel = (props) => {
  const populateTemplate = (str) => replaceTermFromDict(str, props);
  const heading = populateTemplate(mabcBaseModel.heading);
  const subheading = populateTemplate(mabcBaseModel.subheading);
  const ctaHeading = populateTemplate(mabcBaseModel.ctaHeading);
  const steps = mabcBaseModel.steps.map((step) => Object.keys(step)
    .reduce((obj, key) => {
      // only do the string interpolation thing on select keys
      if (!['heading', 'body'].includes(key)) {
        // eslint-disable-next-line
        obj[key] = step[key];
      } else {
        // eslint-disable-next-line
        obj[key] = populateTemplate(step[key]);
      }
      return obj;
    }, {}));
  return {
    ctaHeading,
    heading,
    subheading,
    steps,
  };
};
